import { useLanguage } from 'domains/language/useLanguage';
import { useQuery } from 'react-query';
import { TypeLearningPathsFields } from 'types/contentful/clinical';
import ContentService from 'utils/contentful/contentfulService';

export const getLearningPath = (learningPathID: string, locale?: string): Promise<TypeLearningPathsFields> => {
  return ContentService.clients.clinical
    .getEntry<TypeLearningPathsFields>(learningPathID, {
      locale: locale,
      include: 10,
    })
    .then(data => data.fields as TypeLearningPathsFields);
};

export const useLearningPath = (learningPathID: string) => {
  const { currentContentfulLocale: locale } = useLanguage();
  return useQuery(['learning-path', learningPathID, locale], () => getLearningPath(learningPathID, locale));
};
